<template>
    <div class="container container-main-noticies">
        <div class="row row__primary-block">
            <div class="col-12">
                <Carousel 
                    :slider="slider" 
                    width="1120" 
                    height="456" 
                    css_class="main-banner-2" />
            </div>
        </div>

        <Secondary :main="main" :small="small" />
    </div>
</template>

<script>
import Carousel from '@/components/home/header/Carousel'
import Secondary from '@/components/home/header/Secondary'

export default {
    name: 'Header02',
    props:['slider', 'main', 'small'],
    components: {Carousel, Secondary},
}
</script>